// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M8OTOUl4S87DSJcWO87X{justify-content:space-between;align-items:center;display:flex}.M8OTOUl4S87DSJcWO87X.mrzwjFppwXQuMwzP4nE2{flex-direction:column;align-items:flex-start;gap:4px}.ojsqqppmmCsxSm_RJ956{flex:0 0 125px;min-height:32px}.ojsqqppmmCsxSm_RJ956.mrzwjFppwXQuMwzP4nE2{flex:none;min-height:0}.DJTMJ4ouILsDtCnWamh4{width:100%}.MkuEJ3sGDHcoOd0rAasA{color:var(--content-primary-primary)}.MkuEJ3sGDHcoOd0rAasA span{color:var(--content-primary-tertiary)}.nKll0uRHdVAh0PnPxmm7{align-items:center;gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `M8OTOUl4S87DSJcWO87X`,
	"vertical": `mrzwjFppwXQuMwzP4nE2`,
	"label": `ojsqqppmmCsxSm_RJ956`,
	"input": `DJTMJ4ouILsDtCnWamh4`,
	"text": `MkuEJ3sGDHcoOd0rAasA`,
	"wrapPlaceholder": `nKll0uRHdVAh0PnPxmm7`
};
export default ___CSS_LOADER_EXPORT___;
